import React, { useContext, useEffect, useState } from "react";
import About from "../../components/about";
import Section from "../../components/section";
import Speakers from "../../components/speakers";
// import SponsorBox from "../../components/sponsor/sponsorBox";
import Sponsors from "../../components/sponsor/sponsors";
import Context from "../../context/Context";
import { Speaker } from "../../interfaces/interfaces";
import NewHero from "../hero/new";

const Main = () => {
  const data = useContext(Context);
  const speakers: Speaker[] = data.speakers;
  const { singlePage, sponsors, sponsorLevels, isSpeakerBioEnabled } = data;
  const levels = sponsorLevels ? sponsorLevels : ["diamond"];
  const [sponsorsWithLevels, setSponsorsWithLevels] = useState({});

  useEffect(() => {
    const sWithLevels = {};

    levels.map((sponsorLevel) => {
      const sponsorsAtLevel = sponsors.filter(sponsor => sponsor?.sponsorLevel?.toLowerCase() === sponsorLevel);
      sWithLevels[sponsorLevel] = sponsorsAtLevel;
    });

    setSponsorsWithLevels(sWithLevels);
  }, []);

  return (
    <div id="main-container">
      <NewHero />
      {singlePage && (
        <>
          <div className="wrapper">
            <div className="container">
              <div className="child">
                <Section id="About">
                <About />
                </Section>
              </div>
              
                <Section id="Speakers" className="landing-page-speakers">
                  <Speakers speakers={speakers} isSpeakerBioEnabled={isSpeakerBioEnabled} />
      </Section>
                {/*<div className="child speakers-and-sponsorcta">
                  <a id="sponsors"></a>
                <Section id="Sponsors" className="become-a-sponsor">
                    <h2>Become a Sponsor</h2>
                    <div className="spontextgrid"><p>For more information about sponsoring GDIT EMERGE: AI on the Frontlines, <br />
                      contact us at <a href="mailto:gditai.sponsorships@scoopnewsgroup.com?subject=2024 GDIT EMERGE: AI on the Frontlines Sponsorship Inquiry">gditai.sponsorships@scoopnewsgroup.com</a>.</p> <a href="mailto:gditai.sponsorships@scoopnewsgroup.com?subject=2024 GDIT EMERGE: AI on the Frontlines Sponsorship Inquiry" className="pdfButton" target="_blank">Contact Us</a></div>
                 
                  
                </Section>
    </div>*/}
                
            </div>
          </div>
          
          {/* <SponsorBox /> */}
          {/*<Section id="Sponsors" className="sponsors-section">
            <Sponsors sponsorsWithLevels={sponsorsWithLevels} />
      </Section>*/}
          
        </>
      )}
    </div>
  );
};

export default Main;
